import { render, staticRenderFns } from "./role-inspector-edit.vue?vue&type=template&id=4987b98e&scoped=true"
import script from "./role-inspector-edit.vue?vue&type=script&lang=js"
export * from "./role-inspector-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987b98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4987b98e')) {
      api.createRecord('4987b98e', component.options)
    } else {
      api.reload('4987b98e', component.options)
    }
    module.hot.accept("./role-inspector-edit.vue?vue&type=template&id=4987b98e&scoped=true", function () {
      api.rerender('4987b98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/role-inspector-edit.vue"
export default component.exports